import * as React from "react";
import { StyleSheet, View, ScrollView, ImageBackground } from "react-native";
import {
  Text,
  Provider as PaperProvider,
  DefaultTheme,
  Button,
} from "react-native-paper";
import { connect } from "react-redux";
import routes from "../../routing/routes";
import {
  blackColor,
  whiteColor,
  removeAccountColor,
} from "../../common/colors";
import ModalHeader from "../../common/ModalHeader";
import screenBackground from "./../Images/firstScreenBackground.png";

const DeleteProfilePage = (props) => {
  const theme = {
    ...DefaultTheme,
    roundness: 0,
    colors: {
      ...DefaultTheme.colors,
      primary: blackColor,
    },
  };

  const back = () => props.navigation.navigate(routes.EditProfilePage);
  const close = () => props.navigation.navigate(routes.Settings);

  return (
    <PaperProvider theme={theme}>
      <View style={styles.wrapper}>
        <View style={styles.containerButtons}>
          <ModalHeader back={back} close={close} />
        </View>
        <ImageBackground
          source={screenBackground}
          style={styles.screenBackground}
        >
          <View style={styles.container}>
            <ScrollView style={styles.scrollView}>
              <View style={styles.manywords}>
                <Text style={styles.title}>Usuwanie Konta </Text>
                {/* <Text style={styles.headermessage}>
              Przed rozpoczęciem parę słów wstępu...
            </Text> */}
                <Text style={styles.contentContainer}>
                  Konto o nazwie{" "}
                  <Text style={styles.userAccount}>
                    {props?.user?.user.displayName}
                  </Text>{" "}
                  zostanie trwale
                  <Text style={styles.removeAccount}>
                    {" "}
                    usunięte<Text>. </Text>
                  </Text>
                </Text>
                <Text style={styles.contentContainer}>
                  Czy jesteś pewien, że na pewno chcesz
                  <Text style={styles.removeAccount}>
                    {" "}
                    usunąć<Text> </Text>
                  </Text>
                  Swoje konto?
                </Text>
                <View style={styles.choiceContainer}>
                  {/* <Text style={styles.choiceNo}>Nie</Text>
                                   <Text style={styles.choiceYes}>Tak</Text> */}
                  <Button
                    icon=""
                    mode="text"
                    onPress={() =>
                      props.navigation.navigate(routes.EditProfilePage)
                    }
                  >
                    Nie
                  </Button>
                  <Button
                    icon=""
                    mode="text"
                    onPress={() => alert("Twoje konto zostało usunięte.")}
                  >
                    Tak
                  </Button>
                </View>
              </View>
            </ScrollView>
          </View>
        </ImageBackground>
      </View>
    </PaperProvider>
  );
};
const mapStateToProps = (state) => {
  const user = state.user;

  return { user };
};
export default connect(mapStateToProps)(DeleteProfilePage);

const styles = StyleSheet.create({
  wrapper: {
    alignItems: "center",
    position: "absolute",
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    paddingTop: 35,
    width: "100%",
    backgroundColor: whiteColor,
  },
  back: {
    paddingRight: 100,
    alignItems: "flex-end",
    display: "flex",
  },
  close: {
    paddingLeft: 200,
    paddingRight: 100,
  },
  icons: {
    flexDirection: "row",
    flexWrap: "wrap",
    justifyContent: "space-between",
    alignItems: "flex-start",
    width: 0,
  },
  iconItemLeft: {
    width: "50%",
    alignItems: "flex-start",
  },
  iconItemRight: {
    width: "50%",
    alignItems: "flex-end",
  },
  containerButtons: {
    backgroundColor: whiteColor,
    width: 360,
    alignItems: "center",
    alignContent: "flex-start",
    justifyContent: "flex-start",
  },
  container: {
    backgroundColor: whiteColor,
    width: 360,
    alignItems: "center",
    alignContent: "flex-start",
    justifyContent: "flex-start",
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
  },
  screenBackground: {
    flex: 1,
    width: "100%",
    height: "100%",
    justifyContent: "center",
    alignItems: "center",
  },
  title: {
    textAlign: "left",
    fontSize: 24,
    paddingBottom: 24,
    paddingTop: 24,
    textTransform: "uppercase",
  },
  headermessage: {
    textAlign: "left",
    fontSize: 14,
    padding: 6,
    lineHeight: 18.75,
    letterSpacing: 1.25,
    paddingRight: 48,
    paddingLeft: 0,
    paddingTop: 24,
    paddingBottom: 24,
  },
  manywords: {
    paddingLeft: 26,
    paddingRight: 26,
    paddingBottom: 26,
    alignItems: "stretch",
  },
  scrollView: {
    backgroundColor: whiteColor,
    paddingBottom: 30,
  },
  contentContainer: {
    textAlign: "left",
    fontSize: 13,
    padding: 0,
    lineHeight: 22,
    letterSpacing: 1.25,
    paddingRight: 0,
    paddingLeft: 0,
    paddingBottom: 2,
    paddingTop: 18,
  },
  choiceContainer: {
    flexDirection: "row",
    justifyContent: "space-around",
    paddingTop: 20,
    paddingBottom: 0,
    fontSize: 24,
    padding: 6,
    lineHeight: 18.75,
    letterSpacing: 1.25,
    paddingLeft: 0,
  },
  removeAccount: {
    color: removeAccountColor,
    fontWeight: "700",
  },
  userAccount: {
    color: blackColor,
    fontWeight: "700",
  },
});
